import { io } from "socket.io-client";

class Channel {
    socket;
    name;
    authToken;
    events = {};
    listeners = {};
    subscribed = false;

    constructor(socket, name, authToken) {
        this.name = name;
        this.socket = socket;
        this.authToken = authToken;
        this.subscribe();
    }

    subscribe() {
        if (!this.subscribed) {
            this.socket.emit('subscribe', { channel: this.name, authToken: this.authToken});
            this.subscribed = true;
        }
    }

    unsubscribe() {
        if (this.subscribed) {
            this.unbind();
            this.socket.emit('unsubscribe', { channel: this.name});
            this.subscribed = false;
        }
    }

    setSubscribed(val) {
        this.subscribed = val;
    }

    listen(event, callback) {
        this.on(event, callback);
        return this;
    }

    stopListening(event, callback = false) {
        this.unbindEvent(event, callback);
        return this;
    }

    on(event, callback) {
        this.listeners[event] = this.listeners[event] || [];
        if (!this.events[event]) {
            this.events[event] = (data) => {
                if (this.listeners[event]) {
                    this.listeners[event].forEach((cb) => cb(data));
                }
            };
            this.socket.on(event, this.events[event]);
        }
        this.listeners[event].push(callback);
        return this;
    }

    unbind() {
        Object.keys(this.events).forEach((event) => { this.unbindEvent(event)});
    }

    unbindEvent(event, callback = false) {
        this.listeners[event] = this.listeners[event] || [];
        if (callback)
            this.listeners[event] = this.listeners[event].filter((cb) => cb !== callback);
        if (!callback || this.listeners[event].length === 0) {
            if (this.events[event]) {
                this.socket.removeListener(event, this.events[event]);
                delete this.events[event];
            }
            delete this.listeners[event];
        }
    }
}

class Socket {
    socket;
    channels;
    authToken;

    constructor(cb = false) {
        this.socket = io(window.location.host, {
            path: "/socket",
        });
        this.channels = {};
        this.socket.on('connect', () => {
            if(this.socket.id && cb)
                cb(this.socket.id);
            Object.values(this.channels).forEach((channel) => {
                channel.subscribe();
            });
        });
        this.socket.on('disconnect', () => {
            Object.values(this.channels).forEach((channel) => {
                channel.setSubscribed(false);
            });
        });
    }

    setAuthToken(token) {
        this.authToken = token;
    }

    channel(name) {
        if (!this.channels[name]) {
            this.channels[name] = new Channel(this.socket, name, this.authToken);
        }
        return this.channels[name];
    }

    leave(name) {
        if (this.channels[name]) {
            this.channels[name].unsubscribe();
            delete this.channels[name];
        }
    }

    disconnect() {
        this.socket.disconnect();
    }
}

export const socketInstance = new Socket(socket_id => {
  axios.defaults.headers.common['X-Socket-Id'] = socket_id;
});

export const useSocket = () => {
  return socketInstance;
}

export default {
  install: (app) => {
    app.config.globalProperties.$socket = socketInstance;
    app.provide('socket', socketInstance);
  }
}
